__turbopack_context__.v({
  "className": "notosanskr_2ec8c501-module__cM7bdq__className",
  "variable": "notosanskr_2ec8c501-module__cM7bdq__variable",
});
